"use client";

import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  SessionStorageConstants,
  SessionStorageUtils,
} from "@thriwe-2-0/thriwe-ui-utils";
import { usePathname } from "next/navigation";
import Image from "next/image";
import { RxChevronDown } from "react-icons/rx";

const LanguageDropdown = () => {
  const { i18n } = useTranslation();
  const pathname = usePathname();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language || "en");
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    {
      code: "en",
      label: "English",
      iconPath: "/common-images/flag_en.png",
      short: "En",
    },
    {
      code: "ksa",
      label: "Arabic",
      iconPath: "/common-images/flag_ksa.png",
      short: "Ar",
    },
  ] as const;

  type LanguageCode = (typeof languages)[number]["code"];

  const changeLanguage = (language: LanguageCode) => {
    if (!languages.some((lang) => lang.code === language)) return; // Ensure valid language

    i18n.changeLanguage(language);
    setCurrentLanguage(language);
    SessionStorageUtils.saveToSessionStorage(
      SessionStorageConstants.LANGUAGE,
      language
    );
    setIsOpen(false);
    window.location.reload();
  };

  useEffect(() => {
    let savedLang = SessionStorageUtils.getFromSessionStorage(
      SessionStorageConstants.LANGUAGE
    );
    if (!savedLang || !languages.some((lang) => lang.code === savedLang)) {
      savedLang = "en";
      SessionStorageUtils.saveToSessionStorage(
        SessionStorageConstants.LANGUAGE,
        savedLang
      );
    }
    i18n.changeLanguage(savedLang);
    setCurrentLanguage(savedLang);
  }, []);

  const currentLangData = languages.find(
    (lang) => lang.code === currentLanguage
  );

  return (
    <div className="language-dropdown">
      <button onClick={() => setIsOpen(!isOpen)} className="language-button">
        {currentLangData?.iconPath && (
          <Image src={currentLangData.iconPath} width={22} height={15} alt="" />
        )}
        <span>
          {currentLangData?.short}
          <RxChevronDown size={20} />
        </span>
      </button>

      {isOpen && (
        <div className="dropdown-lang-menu">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              className={`dropdown-lang-item ${
                currentLanguage === lang.code ? "active" : ""
              }`}
            >
              <Image src={lang.iconPath} width={22} height={15} alt="" />
              {lang.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageDropdown;
